import { searchWithDiacritics } from '@/helpers/searchWithDiacritics';

export const agencyCompanyFilterMixin = {
  data() {
    return {
      filteredAgencyCompanies: [],
    };
  },
  watch: {
    agencyCompanies: {
      immediate: true,
      handler() {
        this.filteredAgencyCompanies = this.agencyCompanies;
      },
    },
  },
  methods: {
    agencyCompaniesFilterMethod(query) {
      this.filteredAgencyCompanies = searchWithDiacritics(query, this.agencyCompanies, ['name']);
    },
    handleAgencyCompaniesVisibleChange() {
      setTimeout(() => {
        this.filteredAgencyCompanies = this.agencyCompanies;
      }, 50);
    },
  },
};
